import { Box, Image, Spinner, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import InspirationBoard3 from "../../../assets/InspirationBoardAssets/InspirationBoard3.png";

import { BASE_URL_WISHLIST } from "../../../Redux/App/action";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const InspirationCategory = () => {
  const [catData, setCatData] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
      </Box>
    );
  };

  const getCategoryData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${BASE_URL_WISHLIST}/category/getListCategory`,
        { withCredentials: true },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Token: 123456,
          },
        }
      );
      if (response.status === 200) {
        setCatData(response.data.payload);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCategoryData();
  }, []);

  if (isLoading) {
    return (
      <Box h="80vh">
        <Loader />;
      </Box>
    );
  }

  return (
    <Box>
      <Box w={"100%"}>
        <Image
          src={InspirationBoard3}
          alt="Inspiration Board"
          w={{ base: "100%", md: "98%" }}
          m={"auto"}
        />
        <Text
          width="100%"
          margin={"auto"}
          className="oswald-font"
          fontWeight="bold"
          fontSize={{ base: "10px", md: "20px" }}
          color="black"
          textAlign="center"
          opacity="1"
          mt={"-2%"}
          mb={10}
        >
          Your total point is{" "}
          <span
            style={{
              fontFamily: "Lato",
              fontSize: "semibold",
              color: "#9554DF",
            }}
          >
            3000 pts
          </span>
        </Text>
      </Box>
      <Box
        margin={"auto"}
        p={"2"}
        className="lato-font"
        fontWeight={"regular"}
        fontSize={"16px"}
        mt={10}
      >
        <Text>
          Are you in search of the perfect gift to make a lasting impression on
          your loved ones or colleagues? Look no further than our curated
          Inspiration
          <br /> Boards, designed to help you find the ideal gift for any
          occasion. From corporate events to weddings, birthdays to
          anniversaries, and even eco-
          <br />
          friendly green gifts for the environmentally conscious, we have you
          covered.
        </Text>
      </Box>
      <Box
        w={"95%"}
        m={"auto"}
        mt={10}
        display={"grid"}
        gridTemplateColumns={{ md: "repeat(4,1fr)", base: "repeat(1,1fr)" }}
        gap={2}
        justifyContent={"center"}
        mb={10}
      >
        {catData &&
          catData.map((inspirationCategory, i) => (
            <Image
              src={inspirationCategory.imgUrl}
              key={i}
              onClick={() =>
                navigate(
                  `/inspirationDashboard/${inspirationCategory.categoryName}`
                )
              }
              cursor={"pointer"}
            />
          ))}
      </Box>
      <Box
        margin={"auto"}
        p={"2"}
        className="lato-font"
        fontWeight={"regular"}
        fontSize={"16px"}
        mt={5}
        mb={10}
      >
        <Text>
          No matter the occasion, Wishfy's Inspiration Boards are your go-to
          resource for finding the perfect gift that speaks volumes. Browse our
          carefully curated
          <br /> collections to discover unique, thoughtful, and meaningful
          presents that will leave a lasting impression. Make gifting an art
          with Wishfy!
        </Text>
      </Box>
    </Box>
  );
};

export default InspirationCategory;
